import { IVideoPlayerComponent } from "front-end/components/video-box/factories/video-player.component";
import { IVideoPlayerFactory } from "front-end/components/video-box/factories/video-player.factory";
import { VideoPlayerFactoryBase } from "front-end/components/video-box/factories/video-player.factory.base";
import { YoutubePlayerComponent } from "front-end/components/video-box/factories/youtube/youtube-player.component";
import { scriptLoaderService } from "front-end/services/scripts-loader.service";
import { BehaviorSubject, filter, mergeMap, Observable, Subject } from "rxjs";

class YoutubeVideoPlayerFactory extends VideoPlayerFactoryBase implements IVideoPlayerFactory {
    private _apiReadySubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    public constructor() {
        window.onYouTubePlayerAPIReady = (): void => {
            this._apiReadySubject.next(true);
        };

        super();
    }

    public createPlayer(frameId: string): Observable<IVideoPlayerComponent> {
        const videoFrameElement =  this.setupFrame(frameId);

        return scriptLoaderService.loadScript("https://www.youtube.com/player_api")
            .pipe(
                mergeMap(() => this._apiReadySubject),
                filter(isApiReady => isApiReady),
                mergeMap(() => {
                    const player = new YoutubePlayerComponent();

                    const playerReadySubject = new Subject<IVideoPlayerComponent>();

                    const internalPlayer = new YT.Player(videoFrameElement.attr("id"), {
                        events: {
                            onReady: (): void => {
                                player.init(internalPlayer);
                                playerReadySubject.next(player);
                                playerReadySubject.complete();
                            }
                        }
                    });

                    return playerReadySubject.asObservable();
                })
            );
    }
}

export const youtubeVideoPlayerFactory = new YoutubeVideoPlayerFactory();
